import { convertObjectKeysCase } from '@frontend/duck-tape';
import type { FeatureMap, GrowthBook } from '@frontend/react';
import { initGrowthBook } from '@frontend/react';
import { initCio, initSegment, initSentry } from '@frontend/web-utils';
import { Env } from './env';

// eslint-disable-next-line fp/no-let
let growthbook: GrowthBook<FeatureMap>;

// eslint-disable-next-line fp/no-let
let wasInitExecuted = false;

// Technically this function should be made asynchronous because of Growthbook, but we don't run into race conditions
// when using it in the Growthbook context wrapper
export const initApp = () => {
  if (wasInitExecuted) {
    return { growthbook };
  }

  initSentry({ dsn: Env.VITE_SENTRY_DSN, env: Env.VITE_ENV });

  const segmentClient = initSegment({ writeKey: Env.VITE_SEGMENT_WRITE_KEY });

  initCio({ window });

  // eslint-disable-next-line fp/no-mutation
  growthbook = initGrowthBook({
    autoInit: true,
    clientKey: Env.VITE_GROWTHBOOK_CLIENT_KEY,
    env: Env.VITE_ENV,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    trackingCallback: async (experiment, result) => {
      return segmentClient.track(
        'Experiment Viewed',
        convertObjectKeysCase(
          {
            experimentId: experiment.key,
            variationId: result.variationId,
          },
          'snakeCase',
        ),
      );
    },
  });

  // eslint-disable-next-line fp/no-mutation
  wasInitExecuted = true;
  return { growthbook, segmentClient };
};
